import React from 'react';
import { FormInterpreter } from '../../state-machines/form-machine';
import { FieldHandler } from '../wizard/hooks';

// export type FieldPropMap<T extends React.ReactElement = React.ReactElement> = {
//   [K in keyof T['props']]: { [propPath: string]: string };
// };

/**
 * @description propPath is a path to a component's property, the corresponding string value has the following format: fieldName.fieldAttr
 * for example given the following Props: { someProp: { someKey: string }, _error: string }
 * the propMap could look like so: { 'someProp.someKey': 'address.meta.someKey', '_error': 'address.errors' }
 */
export type FieldPropMap = { [propPath: string]: keyof FieldHandler | string };

export interface IFormContext {
  formService?: FormInterpreter;
  defaultPropMap: FieldPropMap;
}

export const FormContext = React.createContext<IFormContext>({
  defaultPropMap: {},
});

export default FormContext;
